exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  top: 20px;\n  left: -120px;\n  z-index: 10;\n  display: none;\n  padding: 10px; }\n  :host ul {\n    width: 165px;\n    border: solid 1px #babbc7;\n    background-color: white;\n    border-radius: 4px;\n    z-index: 10;\n    font-size: 12px;\n    padding: 3px 0; }\n  :host ::ng-deep li {\n    list-style: none;\n    text-align: left;\n    margin: 0;\n    text-align: left;\n    padding: 5px 17px;\n    color: #5b6779; }\n  :host ::ng-deep li:hover {\n    background-color: #eff0f4; }\n  :host.active {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/tooltip-button-dropdown/tooltip-button-dropdown.component.scss
// module id = ../../../../../src/app/shared/components/tooltip-button-dropdown/tooltip-button-dropdown.component.scss
// module chunks = 12